import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c6769f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sales-report-new-filter-contact" };
import vSelect from 'vue-select';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
// services
import { fetchFilterContact } from '@/features/SalesReportNew/data/index';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterContact',
    setup(__props) {
        // libs
        const store = useStore();
        const contactSelected = ref({
            key: 'allContacts',
            name: 'Todos os contatos',
        });
        const contactOptions = ref([]);
        const isLoading = ref(false);
        // actions
        const changeSelectedContact = (contact) => store.dispatch('salesReportNew/setContactType', contact);
        const setResetFilters = () => store.dispatch('salesReportNew/setResetFilters');
        const setResetSegment = () => store.dispatch('salesReportNew/setResetSegment');
        const selectContact = (contact) => {
            const key = contact.key;
            changeSelectedContact(key);
        };
        const fetchOptions = () => {
            isLoading.value = true;
            fetchFilterContact()
                .then(response => {
                contactOptions.value = response?.data;
            })
                .finally(() => {
                isLoading.value = false;
            });
        };
        onMounted(() => {
            setResetFilters();
            setResetSegment();
            fetchOptions();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('contact-type')), 1),
                _createVNode(_unref(vSelect), {
                    modelValue: contactSelected.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((contactSelected).value = $event)),
                    label: "name",
                    clearable: false,
                    options: contactOptions.value,
                    loading: isLoading.value,
                    "onOption:selected": selectContact
                }, {
                    option: _withCtx(({ name }) => [
                        _createTextVNode(_toDisplayString(_ctx.$tc(name, 1)), 1)
                    ]),
                    "selected-option": _withCtx(({ name }) => [
                        _createTextVNode(_toDisplayString(_ctx.$tc(name, 1)), 1)
                    ]),
                    "open-indicator": _withCtx(({ attributes }) => [
                        _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                    ]),
                    "no-options": _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('campaign.sales-report.no-results')), 1)
                    ]),
                    _: 1
                }, 8, ["modelValue", "options", "loading"])
            ]));
        };
    }
});
